import React from 'react';

export enum TabType {
  line = 'line',
  box = 'box',
}

export enum TabSize {
  small = 'small',
  medium = 'medium',
}

export interface TabsProps extends React.HTMLAttributes<HTMLDivElement> {
  type?: TabType;
  size?: TabSize;
  defaultActiveIndex?: number;
  activeIndex?: number;
  onTabChange?: (index: number) => void;
  children: React.ReactNode;
}

export interface TabContextValue {
  type: TabType;
  size: TabSize;
  activeIndex: number;
  setActiveIndex: (index: number) => void;
}

interface TabBaseProps {
  index?: number; // Internal prop - injected by Tabs
  leftIcon?: React.ReactNode;
  topIcon?: React.ReactNode;
  rightIcon?: React.ReactNode;
  children?: React.ReactNode;
  className?: string;
  disabled?: boolean;
  title?: string;
  /** Test selector applied to the rendered tab element (button or link). */
  'data-cy'?: string;
}

interface TabLinkProps extends TabBaseProps {
  href: string;
}

interface TabButtonProps
  extends TabBaseProps,
    Omit<React.ButtonHTMLAttributes<HTMLButtonElement>, keyof TabBaseProps> {
  href?: never;
}

export type TabProps = TabLinkProps | TabButtonProps;
